import { InjectionToken } from '@angular/core';

import { Environment } from './environment.interface';

/**
 * @const ENV
 * Injection token for the environment interface to be provided by the applications.
 */
export const ENV: InjectionToken<Environment> = new InjectionToken('ENVIRONMENT');
